

enum Refunding {
	NONE = 'NONE', FULL = 'FULL'
}

export default Refunding;